import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Alert } from '../../../shared/components/alert/Alert';
import { Button } from '../../../shared/components/button/Button';
import LoadingSpinner from '../../../shared/components/UIElements/LoadingSpinner';
import { useHttpClient } from '../../../shared/hooks/http-hook';

function Passcode(props) {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState<string>('');
  const { isLoading } = useHttpClient();
  const { t } = useTranslation();

  const [code, setCode] = useState('');
  const [accepted, setAccepted] = useState(false);

  const handleValueChange = (e) => {
    setErrorMessage('');
    const { value } = e.target;
    setCode(value);
    const valid = /^\d+$/.test(value);
    if ((valid && value.length < 5) || value.length < 1) setCode(value);
    if (valid && value.length === 4) {
      setAccepted(true);
    }
  };

  const handleNavigation = () => {
    navigate('/reset', {
      state: { passcode: true },
    });
  };

  const handleContinue = (e?: React.FormEvent) => {
    if (e) {
      e.preventDefault();
    }
    const el = document.getElementById('passcode');
    if (!code || code.length !== 4) {
      setErrorMessage(t('signin.passcode.error'));
      return;
    }
    if (!props.confirm && code.length === 4) {
      props.handleContinue(code);
    } else if (props.confirm && props.passcode === code) {
      el.classList.add('confirmed');
      setTimeout(() => {
        props.handleContinue(code);
      }, 2000);
    } else {
      setErrorMessage(t('R054'));
      el.classList.add('wrong');

      // Only reset on signup screen
      if (props.handleReset) {
        setTimeout(() => {
          props.handleReset();
        }, 2000);
      }
    }
  };

  useEffect(() => {
    if (props.errorMessage && props.errorMessage.length > 0) {
      setErrorMessage(props.errorMessage);
      setTimeout(() => {
        setCode('');
      }, 2000);
    }
  }, [props.errorMessage]);

  return (
    <form onSubmit={handleContinue}>
      <label className="not_logged_label" htmlFor="passcode">
        {t('R072')}
      </label>
      <div className="passcode">
        <input
          type="password"
          className="code_input passcode"
          id="passcode"
          name="passcode"
          minLength={4}
          maxLength={4}
          onChange={handleValueChange}
          value={code}
          aria-label={t('R072')}
          data-testid="passcode-input"
        />
      </div>
      {isLoading && <LoadingSpinner asOverlay />}
      {errorMessage && (
        <Alert
          type="error"
          message={errorMessage}
          id="passcode-error"
          dataTestId="passcode-error"
          isVisible
          isAssessive
        />
      )}
      {!isLoading && (
        <Button
          type="submit"
          id="continue"
          className={accepted ? 'accepted' : 'declined'}
          dataTestId="passcode-submit-button"
        >
          {t('R013')}
        </Button>
      )}
      <Button
        className="signin"
        onClick={handleNavigation}
        variant="secondary"
        type="button"
        dataTestId="forgot-passcode-button"
      >
        {t('R122')}
      </Button>
    </form>
  );
}

export default Passcode;
